import { Badge } from '@/components/ui/Badge/badge';
import { LINE_THROUGH_CLASSES } from '@/lib/styles';
import { cn } from '@/lib/utils';
import type { Workorder, WorkorderProgress } from '@certhon/models';

const PROGRESS_CONFIG: Record<
  WorkorderProgress,
  {
    label: string;
    variant: 'default' | 'secondary' | 'outline' | 'positive' | 'destructive';
  }
> = {
  concept: { label: 'Concept', variant: 'outline' },
  scheduled: { label: 'Scheduled', variant: 'secondary' },
  scheduled_non_digital: { label: 'Scheduled', variant: 'secondary' },
  completed: { label: 'Completed', variant: 'positive' },
  cancelled: { label: 'Cancelled', variant: 'destructive' },
};

interface ProgressBadgeProps extends Pick<Workorder, 'progress' | 'completed'> {
  className?: string;
}

export function ProgressBadge({
  progress,
  completed,
  className,
}: ProgressBadgeProps) {
  const config = PROGRESS_CONFIG[progress];

  return (
    <Badge
      variant={config.variant}
      className={cn(className, completed && LINE_THROUGH_CLASSES)}
    >
      {config.label}
    </Badge>
  );
}
